import { ITeam, ITeamSettings } from "store/entities/teams";

import { IKeyAny } from "../api-client";
import { BaseApi } from "../base";

type ICreateTeamPayload = Partial<ITeam> & {
  autoassignmentAgentIDs?: string[];
};

function parseCreateTeamPayload(payload: ICreateTeamPayload): IKeyAny {
  return {
    name: payload.name,
    agentIDs: payload.agentIds,
    replyAddressID: payload.replyAddressID,
    replyName: payload.replyName,
    autoassignmentAgentIDs: payload.autoassignmentAgentIDs,
  };
}

interface IUpdateTeamPayload {
  name?: string;
  agentIds?: string[];
  settings?: Partial<ITeamSettings>;
  replyAddressID?: string | null;
  replyName?: string | null;
  autoassignmentAgentIDs?: string[];
}

interface IBatchUpdateTeamPayload {
  fields: {
    replyAddressID?: string | null;
    templateID?: string | null;
    replyName?: string | null;
    settings?: Partial<ITeamSettings>;
  };
  ids: string[];
}

function parseUpdateTeamPayload(payload: IUpdateTeamPayload): IKeyAny {
  const { name, agentIds, settings, replyAddressID, replyName, autoassignmentAgentIDs } = payload;
  return {
    ...(name && { name }),
    ...(agentIds && { agentIDs: agentIds }),
    ...(settings && { settings }),
    ...(replyAddressID !== undefined && { replyAddressID }),
    ...(replyName !== undefined && { replyName }),
    ...(autoassignmentAgentIDs !== undefined && { autoassignmentAgentIDs }),
  };
}

export default class TeamApi extends BaseApi {
  protected readonly prefix = "teams";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get("");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createTeam = (data: Partial<ITeam>) => this.post("", parseCreateTeamPayload(data));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateTeam = (id: string, data: IUpdateTeamPayload) => this.patch(id, parseUpdateTeamPayload(data));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteTeam = (id: string) => this.delete(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  batchUpdate = (payload: IBatchUpdateTeamPayload) => this.patch("", payload);
}
